module.exports = __webpack_public_path__ + "static/roselyn-7b9daac2fd1fa0ab63237e78592bb1ff.svg";